import React, { useEffect } from "react";
import ShellCard from "../../components/ShellCard";
import heroBanner from "../../assets/images/4-hour-bdi-online.png";

const Curso4HorasBDI = () => {
    useEffect(() => {
        document.title = "Curso de 4 Horas BDI - Metro Traffic School";
    }, []);

    const registrationLink = "https://courses.metrotrafficschool.com/onlinecourses/index.php/register?awc_id=NDc2";

    return (
        <>
            <section className="hero-slider-section">
                <div
                    className="hero-banner"
                    style={{
                        backgroundImage: `url(${heroBanner})`,
                    }}
                >
                    <div className="banner-text-container">
                        <div className="banner-heading">
                            <h1 className="banner-title">Curso de 4 horas BDI</h1>
                            <p className="banner-subheading">Estado de la Florida Certificado</p>
                        </div>
                    </div>
                </div>
            </section>

            <div className="container py-5">
                <ShellCard>
                    <div className="mb-4">
                        <h3 className="mb-4" style={{ color: "var(--metro-yellow)" }}>Detalles del Curso</h3>
                        <p className="text-white">
                            Para una descripcion completa del curso de 4 horas BDI por favor{" "}
                            <a
                                href="/4-hour-bdi"
                                className="text-warning fw-bold"
                            >
                                oprima aqui
                            </a>.
                        </p>
                    </div>

                    <div className="mb-4">
                        <h3 className="mb-4" style={{ color: "var(--metro-yellow)" }}>Beneficios del Curso por Internet</h3>
                        <ul className="text-white ms-3" style={{ listStyleType: "disc" }}>
                            <li className="mb-2">Todo el material que necesita esta en la pagina de internet...registrese ahora...</li>
                            <li className="mb-2">Preguntas o questionario de multiples respuestas. Preguntas verdadero/ falso.</li>
                            <li className="mb-2">Opcion de tomar el curso en secciones y poder accesar (entrar y/o salir) de su cuenta cuantas veces quiera en su propio tiempo.</li>
                            <li className="mb-2">Pagina de internet accesible las 24 horas al dia 7 dias a la semana.</li>
                            <li className="mb-2">Retomar el examen gratis si no lo pasa la primera vez.</li>
                            <li className="mb-2">Servicio al cliente durante horarios de oficina para cualquier pregunta o ayuda necesaria.</li>
                            <li className="mb-2">Nuevo en el internet? Servicio al cliente por telefono y correo electronico gratis.</li>
                            <li className="mb-2">Garantizado no puntos en el record de su licensia por esa multa especifica.</li>
                            <li className="mb-2">Garantizado no aumento en el seguro del carro si no hubo ningun accidente o choque envuelto en la multa (statute 626.9541).</li>
                        </ul>
                    </div>

                    <div className="mb-4">
                        <h3 className="mb-4" style={{ color: "var(--metro-yellow)" }}>Cómo funciona??</h3>
                        <p className="text-white mb-3">
                            El curso esta divido en 4 secciones de 50 minutos cada una, con un receso de 10 minutos despues de cada seccion. Para poder obtener credito por el tiempo completado en cada seccion por favor oprima el boton de guardar tiempo (save time) antes de salirse de la pagina de internet, para que cuando regrese a su cuenta lo lleve directo a donde habia terminado sin tener que volver a repetir lo que ya habia completado. Despues de haber leido todo el material y haber contestado todas la preguntas correctamente entonces tome el examen final y presione el boton que dice: submitir. El examen final esta compuesto de 40 preguntas de verdadero/falso y respuestas multiples. Debe contestar correctamente por lo menos 80% del examen (32 preguntas) correctas para pasar el curso. Puede retomar el examen gratis cuantas veces sean necesarias para pasar el examen.
                        </p>
                        <p className="text-white mb-3">
                            El proceso para registrarse al curso es facil, simplemente llene la informacion que le piden en la{" "}
                            <a
                                href={registrationLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-warning fw-bold"
                            >
                                pagina de registracion
                            </a>
                            , y responda 10 preguntas de seguridad. Apenas el proceso de registracion sea completado, simplemente ponga su nombre de usuario y contraseña donde se lo piden para accesar la cuenta y poder empezar el curso cuando quiera.
                        </p>
                        <p className="text-white">
                            ...o simplemente llame a nuestro centro de registracion 1-888-41-METRO para hacer su registracion por telefono.
                        </p>
                    </div>

                    <div className="mb-4">
                        <h3 className="mb-4" style={{ color: "var(--metro-yellow)" }}>El precio del curso es $19.50</h3>
                        <div className="mb-4">
                            <a
                                href={registrationLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-lg px-5 py-3 fw-bold text-dark metro-btn-primary"
                                style={{ backgroundColor: "var(--metro-yellow)", border: "none" }}
                            >
                                Registrese Ahora!
                            </a>
                        </div>
                        <p className="text-white">
                            Si no tiene tarjeta de credito puede mandar por correo a nuestra oficina principal un money order y cuando lo recibamos, le llamaremos para registrarlo y darle un nombre de usuario y contraseña para que pueda accesar su cuenta. Asegurese de poner su nombre y numero telefonico en el money order para poder contactarlo/a.
                        </p>
                    </div>
                </ShellCard>
            </div>
            <div className="container" style={{ marginBottom: "32px" }}>
                <div className="row text-white">
                    <p>
                        Superb Customer Service
                    </p>
                    <p>
                        At Metro we always aim to provide an exceptional and pain free educational experience. We do this by only offering state approved courses that use cutting edge technology and always providing first rate customer service. Here are some reviews left by past clients!
                    </p>
                </div>
            </div>
        </>
    );
};

export default Curso4HorasBDI;
